import { useEffect, useState } from 'react';
import { BREAKPOINTS } from 'common/constants';

export const useCheckMobile = () => {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia(`(max-width: ${BREAKPOINTS.MOBILE}px)`).matches,
  );
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(
        window.matchMedia(`(max-width: ${BREAKPOINTS.MOBILE}px)`).matches,
      );
    };
    window.addEventListener('resize', checkIsMobile);
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  return isMobile;
};
